/**
 * Inline MSW response for the account picker on the pro number blocks page. Spread into the
 * ENV-wide INLINE_RESPONSES map.
 *
 * These are Vitran's real accounts: the 25lb services bill to FTI020 and the rest to FTI002
 * (VitranIntegration.getCarrierAccountNumberForShipment). No customer accounts appear because
 * Vitran's live agreements carry an empty account number, which the service drops — an account
 * nothing can be billed to is not somewhere a block can point.
 *
 * MSW ignores the query string here, so every carrier gets this same answer in mock mode.
 */
export const CARRIER_PRO_BLOCK_INLINE_RESPONSES = {
  "/apollo/carrier-pro-block/get-carrier-accounts": [
    {
      accountNumber: "FTI002",
      description: "FreightSimple",
      isCustomerSpecific: false,
    },
    {
      accountNumber: "FTI020",
      description: "FreightSimple",
      isCustomerSpecific: false,
    },
  ],
};
